export var types = {
    SET_ACTIVE_VABARRAY: 'SET_ACTIVE_VABARRAY',
    SHOW_INDICATOR: 'SHOW_INDICATOR',
};
export var setActiveVABArray_AC = function (activeVabArray) {
    return {
        type: types.SET_ACTIVE_VABARRAY,
        payload: {
            vabArrayValue: activeVabArray,
        },
    };
};
export var showIndicator_AC = function (x, y) {
    return {
        type: types.SHOW_INDICATOR,
        payload: {
            x: x,
            y: y,
        },
    };
};
//# sourceMappingURL=s80_touchpanel.actions.js.map